import { Link } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";

export const IntegrationsSection = () => (
  <Card className="card-surface" data-testid="integrations-card">
    <CardHeader style={{ borderBottom: '1px solid var(--t-border)', padding: '16px 20px' }}>
      <div className="flex items-center gap-3">
        <Link className="w-5 h-5" style={{ color: 'var(--t-text-muted)' }} />
        <div>
          <CardTitle className="text-lg font-semibold" style={{ color: 'var(--t-text)', fontFamily: 'var(--t-heading-font)' }}>
            Integrations
          </CardTitle>
          <CardDescription style={{ color: 'var(--t-text-muted)' }}>Connect with external services</CardDescription>
        </div>
      </div>
    </CardHeader>
    <CardContent className="p-5">
      <p className="text-sm text-center py-6" style={{ color: 'var(--t-text-muted)' }}>No integrations configured. Check back soon for new options.</p>
    </CardContent>
  </Card>
);
